import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import DepositRequestsPage from './DepositRequestsPage.vue'

export const depositRequestsRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_DEPOSIT_REQUESTS,
    name: 'treasury.depositRequests',
    component: DepositRequestsPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Deposit approvals',
      activeMenu: 'Treasury',
    },
  },
]
